import React from "react";

const TopLeftHandle = (props) => {
  return (
    // <img
    //   className=""
    //   draggable="false"
    //   src="../../style/images/custom-icons/top-left-arrow.svg"
    //   style={{ height: "12px", top: "5px", position: "absolute", right: "4px" }}
    // />
    <div
      style={{
        width: "9px",
        height: "9px",
        position: "absolute",
        top: 5,
        right: 6,
        backgroundColor: "white",
        border: "1px solid black",
      }}
    ></div>
  );
};

const TopRightHandle = (props) => {
  return (
    // <img
    //   className=""
    //   draggable="false"
    //   src="../../style/images/custom-icons/top-right-arrow.svg"
    //   style={{ height: "12px", top: "4px", position: "absolute", right: "4px" }}
    // />
    <div
      style={{
        width: "9px",
        height: "9px",
        position: "absolute",
        top: 5,
        right: 5,
        backgroundColor: "white",
        border: "1px solid black",
      }}
    ></div>
  );
};

const BottomRightHandle = (props) => {
  return (
    // <img
    //   className=""
    //   draggable="false"
    //   src="../../style/images/custom-icons/buttom-right-arrow.svg"
    // />
    <div
      style={{
        width: "9px",
        height: "9px",
        position: "absolute",
        top: 5,
        right: 5,
        backgroundColor: "white",
        border: "1px solid black",
      }}
    ></div>
  );
};

const BottomLeftHandle = (props) => {
  return (
    <div
      style={{
        width: "9px",
        height: "9px",
        position: "absolute",
        top: 5,
        right: 5,
        backgroundColor: "white",
        border: "1px solid black",
      }}
    ></div>
  );
};

export { TopLeftHandle, TopRightHandle, BottomRightHandle, BottomLeftHandle };
